import { useEffect } from "react";
import EditProfileLeftSection from "./editProfile/EditProfileLeftSection";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constant/routeNames";

function EditProfile({ handleClick, isActive, anyPlayerActive }: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loggedInUser) {
      navigate(RouteName.pageNotFound);
    }
  }, []);
  return (
    <div className={`${anyPlayerActive ? `mb-[140px]` : `mb-30`}`}>
      <div
        className={
          isActive
            ? "md:pl-[100px] pl-[80px] duration-500 p-2 mt-2 ml-4 "
            : "pl-0 duration-500 p-2 mt-2 ml-3"
        }
      >
        <div
          className="relative min-h-[80vh] overflow-hidden rounded-2xl max-sm:w-[100%]"
          style={{
            color: "#fff",
            backgroundImage: `url('https://cdn.wallpapersafari.com/31/38/qjUg2J.jpg')`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          {/* dim the wallpaper into a subtle backdrop */}
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/60" />
          <div className="pointer-events-none absolute inset-0 bg-black/40" />

          <div className="logeditprofile-back scrollbar-hide relative z-10 w-full">
            <div className="flex w-full">
              <div className="w-full flex-1 min-w-0">
                <EditProfileLeftSection />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditProfile;